<button class="toggle-button"
        (click)="this.sidenavService.toggleSidenav('main')"
        [class.is-flipped]="sidenavService.isExpanded('main')">
  <mat-icon icon>chevron_right</mat-icon>
</button>

<div class="main-nav" [class.collapsed]="!sidenavService.isExpanded('main')">

  @for (item of mainNav(); track item; let index = $index) {
  <div class="nav-child" [class.active]="isActive(item)">
    <a
      [routerLink]="item.path"
      [queryParams]="item.queryParams"
      [queryParamsHandling]="isActive(item) ? 'preserve' : ''"
    >
      <img [src]="item.icon" />
      <span>{{ item.name }}</span>
    </a>
  </div>
  }

  <div class="nav-spacer"></div>
  <div class="nav-child">
    <app-user-profile></app-user-profile>
  </div>

</div>
